// extracted by mini-css-extract-plugin
export default {"infoCard":"InfoCard_infoCard__S3C+0","infoText":"InfoCard_infoText__KcVUc","infoAnswer":"InfoCard_infoAnswer__-imX4"};